import React from 'react';
import classNames from 'classnames/bind';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import styles from './assets/styles.scss';
import useGamesList from '../../games/hooks/useGamesList';
import GameThumbnail from '../GameThumbnail/GameThumbnail';
import { useMobileOnly } from '../../helpers/responsive';

import IconSlots from '../../assets/img/slots.svg?inline';
import IconTableGames from '../../assets/img/table-games.svg?inline';
import IconGames from '../../assets/img/games.svg?inline';
import IconInhouse from './assets/inhouse.svg?inline';
import IconCasual from './assets/casual.svg?inline';

const cx = classNames.bind(styles);

const categories = [
  { name: '', title: isMobileOnly => (isMobileOnly ? 'All' : 'All Games'), icon: <IconGames /> },
  { name: 'inhouse', title: () => 'In-House', icon: <IconInhouse /> },
  { name: 'slots', title: () => 'Slots', icon: <IconSlots /> },
  { name: 'table', title: () => 'Table', icon: <IconTableGames /> },
  { name: 'casual', title: () => 'Casual', icon: <IconCasual /> },
];

export default function GamesList() {
  const isMobileOnly = useMobileOnly();
  const [gameCategory, setGameCategory] = useQueryParam('category', withDefault(StringParam, categories[0].name));
  const { games } = useGamesList(gameCategory);

  return (
    <>
      <div className={cx('category-selection')}>
        {categories.map(({ name, title, icon }) => (
          <div key={name}>
            <button
              type="button"
              onClick={() => setGameCategory(name)}
              className={cx({ selected: gameCategory === name })}
            >
              {icon}
            </button>
            <span className={cx('small')}>{title(isMobileOnly)}</span>
          </div>
        ))}
      </div>
      <div className={cx('games')}>
        {games.map(({
          url, provider, thumbnailSrc, title,
        }) => (
          <GameThumbnail url={url} provider={provider} thumbnailSrc={thumbnailSrc} title={title} />
        ))}
      </div>
    </>
  );
}
GamesList.propTypes = {};
GamesList.defaultProps = {};
